import { Clock, Ban, LogOut, RefreshCw } from 'lucide-react';
import LogoSynosight from '../assets/synosight-logo-horizontal.svg';

/**
 * Écran affiché quand l'utilisateur est authentifié mais que son compte n'est
 * pas (encore) ACTIVE : PENDING (en attente de validation admin) ou DISABLED.
 *
 * En PENDING, `useAuth` interroge /auth/me en arrière-plan : dès que l'admin
 * active le compte, cet écran disparaît automatiquement au profit de l'app.
 */
export default function AccountGateView({ status, email, onLogout }) {
  const pending = status === 'PENDING';
  const Icon = pending ? Clock : Ban;
  const title = pending ? "Compte en attente d'activation" : 'Compte désactivé';
  const detail = pending
    ? "Votre compte a été créé mais un administrateur doit le valider. Cette page se mettra à jour automatiquement dès l'activation, sans avoir à vous reconnecter."
    : 'Votre compte a été désactivé. Contactez un administrateur pour le réactiver.';
  const accent = pending ? 'var(--warning)' : 'var(--danger)';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        gap: '2rem',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          background: '#fff',
          borderRadius: 22,
          padding: '32px 48px',
          boxShadow: 'var(--shadow-card)',
        }}
      >
        <img src={LogoSynosight} alt="Synosight" style={{ height: 128, width: 'auto', display: 'block' }} />
      </span>

      <div
        role="alert"
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '0.6rem',
          background: pending ? 'rgba(245, 158, 11, 0.1)' : 'rgba(239, 68, 68, 0.1)',
          border: `1px solid ${accent}`,
          padding: '0.85rem 1rem',
          borderRadius: 'var(--radius-md)',
          maxWidth: 480,
        }}
      >
        <Icon size={18} style={{ flexShrink: 0, marginTop: 2, color: accent }} />
        <div style={{ color: 'var(--text)' }}>
          <strong>{title}</strong>
          <div style={{ marginTop: 4, color: 'var(--text-muted)', fontSize: '0.9rem' }}>
            {detail}
          </div>
          {pending && (
            <div
              style={{
                marginTop: 10,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.4rem',
                color: 'var(--text-muted)',
                fontSize: '0.85rem',
              }}
            >
              <RefreshCw size={14} className="spin" />
              Vérification automatique en cours…
            </div>
          )}
        </div>
      </div>

      {email && (
        <div style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          Connecté en tant que <strong style={{ color: 'var(--text)' }}>{email}</strong>
        </div>
      )}

      <button
        onClick={onLogout}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          background: 'var(--glass)',
          color: 'var(--text)',
          border: '1px solid var(--glass-border)',
          padding: '0.6rem 1.25rem',
          borderRadius: 'var(--radius-sm)',
          cursor: 'pointer',
          fontSize: '0.9rem',
        }}
      >
        <LogOut size={16} />
        Se déconnecter
      </button>
    </div>
  );
}
